import * as React from 'react';
import { CSSProperties, Dispatch, SetStateAction, useEffect, useState, useContext, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../store';
import { SxProps, Theme } from '@mui/material';
import { styled, Box } from '@mui/material';
import Button from '@mui/material/Button';
import Menu, { MenuProps } from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { fetchGetApi } from '../../../src/utils/api';

import { GoTriangleDown } from 'react-icons/go';
import { ModalContext } from '../../provider/ModalProvider';
import { SET_UPDATE } from '../../store/common/searchbar';
import { getIdRCheckday, sortingRcheckday } from '../../utils/tools';

interface DropdownNormalProps {
  id?: string;
  contents?: string[];
  type: 'edit' | 'class' | 'custom' | 'class_day' | 'class_day_all' | 'account_calendar';
  title?: string;
  setTitle?: Dispatch<SetStateAction<string>>;
  idx?: number;
  checkCount?: number;
  useDisabled?: boolean;
  onClickItem: (idx: number | string, rcheckday?: string) => void;
  className?: string;
  disabled?: boolean;
  disableOwner?: boolean;
  sx?: SxProps<Theme>;
  menuStyle?: CSSProperties;
  isStatistics?: boolean;
  isChecked?: boolean;
}

interface MenuExtendProps extends MenuProps {
  parent_id?: string;
  isZoom?: boolean;
}

const StyledMenu = styled((props: MenuExtendProps) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'left',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'left',
    }}
    {...props}
  />
))(({ theme, style, ...props }) => ({
  '& .MuiPaper-root': {
    transform: props.isZoom ? 'scale(0.9) !important' : '',
    borderRadius: 2,
    marginTop: theme.spacing(0),
    minWidth: '9rem',
    color: 'var(--black)',
    fontSize: '1rem',
    border: '1px solid var(--gray-2)',
    // borderTop: 'none',
    maxHeight: props.parent_id === 'sms_send' ? '70vh' : '18rem',
    // width: '9rem',
    overflowX: 'auto',
    ...style,
    '& .MuiMenu-list': {
      width: '100%',
      padding: '4px 0',
    },
    '& .MuiMenuItem-root': {
      height: '40px',
      padding: '0 1rem',
      overflow: 'hidden',
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      div: {
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
      },
    },

    '.down': {
      color: '#c0c0c0',
    },
  },
}));
interface StyledButtonProps {
  isStatistics?: boolean;
}
const StyledButton = styled(({ isStatistics, ...rest }: StyledButtonProps & React.ComponentProps<typeof Button>) => (
  <Button {...rest} />
))(({ isStatistics }) => ({
  minWidth: isStatistics ? '7.5rem' : '9rem',
  height: '100%',
  backgroundColor: 'var(--white)',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '0 1rem',
  borderRadius: 4,
  fontSize: '1rem',
  textTransform: 'none',

  '&:hover': {
    backgroundColor: 'var(--white)',
  },
  svg: {
    width: '0.875rem',
    height: '0.875rem',
    marginTop: '-2px',
  },
}));

const DetailDeco = styled('div')(() => ({
  width: '0.875rem',
  height: '0.875rem',
  borderBottom: '1px dotted var(--gray-1)',
  borderLeft: '1px dotted var(--gray-1)',
  position: 'absolute',
  top: 'calc(22px - 0.5rem)',
  left: '1rem',
  transform: 'translateY(-50%)',
}));

const ExposureDivider = styled(Box)(({ theme }) => ({
  width: '90%',
  height: '2px',
  backgroundColor: '#f7f7f7',

  margin: '0.25rem auto',
}));

function DropdownNormal(props: DropdownNormalProps) {
  const dispatch = useDispatch();
  const user_info = useSelector((state: RootState) => state.UserReducer);
  // const { root_visible } = useContext(ModalContext);

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const id = props.id;
  const contents = props.contents;
  const type = props.type;
  const onClickItem = props.onClickItem;
  const className = props.className;
  const disabled = props.disabled;
  const check_count = props.checkCount;
  const use_disabled = props.useDisabled;
  const title = props.title;
  const setTitle = props.setTitle;
  const sx = props.sx;
  const menu_style = props.menuStyle;
  const disable_owner = props.disableOwner;

  const [dropdownContents, setDropdownContents] = useState<
    (
      | string
      | {
          title: string;
          listView: JSX.Element;
        }
    )[]
  >([]);
  const [dropdownTitle, setDropdownTitle] = useState('');
  const [classList, setClassList] = useState<{ label: string; id: number }[]>([]);
  const [clickStatus, setClickStatus] = useState(false);
  const [originClassList, setOriginClassList] = useState<ClassListType[]>([]);
  const [exposureIndex, setExposureIndex] = useState<null | number>(null);
  const checkCntRef = useRef<null | number>();
  const { modal_alert } = useContext(ModalContext);

  useEffect(() => {
    return () => {
      setDropdownContents([]);
      setDropdownTitle('');
      setClassList([]);
      setClickStatus(false);
      setExposureIndex(null);
    };
  }, []);

  useEffect(() => {
    if (type == 'class' || type == 'class_day' || type == 'class_day_all') {
      setDropdownTitle(type == 'class' ? '클래스 전체' : '출석요일 기준');
      setClassDropdownContents();
    } else if (type === 'account_calendar') {
      setDropdownContents([
        {
          title: '결제일 기준',
          listView: (
            <>
              <Box component={'span'} sx={{ paddingLeft: '1.35rem' }}>
                {'결제일 기준'}
              </Box>
            </>
          ),
        },
        {
          title: '정산일 기준',
          listView: (
            <>
              <Box component={'span'} sx={{ paddingLeft: '1.35rem' }}>
                {'정산일 기준'}
              </Box>
            </>
          ),
        },
      ]);
    }
  }, []);

  useEffect(() => {
    setCurrentTitle();
  }, [contents, title]);

  useEffect(() => {
    if (open && contents) {
      const exposure_idx = contents.findIndex(item => `${item}`.includes('exposure'));
      if (Number(exposure_idx) >= 0) {
        setExposureIndex(exposure_idx);
      }
    }
  }, [open]);

  const setCurrentTitle = () => {
    if (contents && contents.length > 0) {
      if (type == 'custom' && title) {
        setDropdownTitle(title);
      } else {
        setDropdownTitle('관리');
      }

      setDropdownContents([...contents]);
    }
  };

  useEffect(() => {
    if (!open) {
      setCurrentTitle();
      setClickStatus(false);
    }
  }, [open]);

  const setClassDropdownContents = async () => {
    const class_res = await fetchGetApi(`/${user_info.cid}/user/${user_info.uid}/class/all`);
    if (class_res.message != 'null') {
      const class_list: ClassListType[] = class_res.message.rows;
      setOriginClassList([...class_list]);
      const tmp_class_list = class_list.map(item => {
        return { label: item.rname ?? '-', id: Number(item.rid) };
      });

      const dropdown_items = class_list.map(item => {
        const rname = item.rname ?? '-';
        return type == 'class'
          ? rname
          : {
              title: rname,
              listView: (
                <>
                  <DetailDeco></DetailDeco>
                  <Box component={'span'} sx={{ paddingLeft: '1.35rem' }}>
                    {rname}
                  </Box>
                </>
              ),
            };
      });

      const tmp_dropdown_list = [...dropdown_items];
      if (type == 'class') {
        // `${type == 'class' ? '클래스 전체' : '출석요일 기준'}`,
        tmp_dropdown_list.unshift('클래스 전체');

        if (id && ['sms_send'].includes(id)) {
          tmp_dropdown_list.push('휴원생', '퇴원생', '미등록생');
        }
      } else if (type == 'class_day_all') {
        tmp_dropdown_list.unshift('출석요일 기준', '당일출석 기준');
      } else {
        tmp_dropdown_list.unshift('출석요일 기준');
      }
      setClassList([...tmp_class_list]);
      setDropdownContents(tmp_dropdown_list);
    } else {
      const tmp_dropdown_list = [`${type == 'class' ? '클래스 전체' : '출석요일 기준'}`];
      setClassList([]);
      setDropdownContents(tmp_dropdown_list);
    }
  };

  function handleMenuClick(idx: number) {
    if (type == 'class' || type == 'class_day' || type == 'class_day_all') {
      dispatch({
        type: SET_UPDATE,
        payload: {
          update: true,
        },
      });
      if (idx == 0) {
        onClickItem('all');
      } else {
        if (idx == 1 && type == 'class_day_all') {
          onClickItem('all_without_checkday');
        } else {
          const uclass_arr = ['휴원생', '퇴원생', '미등록생'];
          if (id && ['sms_send'].includes(id) && uclass_arr.includes(`${dropdownContents[idx]}`)) {
            const uclass_ids: { [key: string]: string } = {
              휴원생: 'SB',
              퇴원생: 'SX',
              미등록생: 'SN',
            };
            onClickItem(uclass_ids[`${dropdownContents[idx]}`]);
          } else {
            let minus_num = 1;
            if (type == 'class_day_all') {
              minus_num = 2;
            }
            const rcheckday_string = getIdRCheckday(originClassList[idx - minus_num].rcheckday.replace(/[,]/g, ', '));
            onClickItem(classList[idx - minus_num].id, rcheckday_string);
          }
        }
      }
    } else {
      onClickItem(idx);
    }
    let title: string;
    if (typeof dropdownContents[idx] === 'string') {
      title = `${dropdownContents[idx]}`;
    } else {
      title = `${(dropdownContents[idx] as { title: 'string'; listView: JSX.Element }).title}`;
    }

    title = title.replace('_require', '');
    title = title.replace('::disabled', '');
    title = title.replace('::exposure', '');
    setDropdownTitle(title);
    if (setTitle) {
      let title: string;
      if (typeof dropdownContents[idx] === 'string') {
        title = `${dropdownContents[idx]}`;
      } else {
        title = `${(dropdownContents[idx] as { title: 'string'; listView: JSX.Element }).title}`;
      }

      title = title.replace('_require', '');
      title = title.replace('::disabled', '');
      title = title.replace('::exposure', '');
      setTitle(title);
    }
    setClickStatus(true);
    handleClose();
  }

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    if (Number.isInteger(check_count) && check_count === 0) {
      modal_alert.openModalAlert('empty', '내역에서 항목 체크 후, 다시 선택해주세요.');
      return;
    }
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const setMenuDisabled = (text: string | JSX.Element): boolean => {
    if (use_disabled && typeof text == 'string') {
      if (text.indexOf('::disabled') >= 0) {
        if (text.indexOf('disabled_require') >= 0) {
          return true;
        } else {
          if (check_count == 1) {
            return false;
          } else {
            return true;
          }
        }
      } else {
        return false;
      }
    } else {
      return false;
    }
  };

  useEffect(() => {
    if (checkCntRef.current === 0 && check_count === 1) {
      const btn = document.getElementById('demo-customized-button');
      if (!btn) return;
      const ripple = document.createElement('span');
      ripple.classList.add('dropdown-ripple');

      btn.appendChild(ripple);
      setTimeout(() => {
        ripple.remove();
      }, 2000);
    }

    checkCntRef.current = check_count;

    () => {
      const ripple = document.querySelector('.ripple');
      if (ripple) {
        ripple.remove();
      }
    };
  }, [check_count]);

  return (
    <>
      <StyledButton
        id='demo-customized-button'
        aria-controls={open ? 'demo-customized-menu' : undefined}
        aria-haspopup='true'
        aria-expanded={open ? 'true' : undefined}
        variant='outlined'
        disableElevation
        disableRipple
        color={'blue'}
        onClick={handleClick}
        endIcon={<GoTriangleDown />}
        className={className}
        disabled={disabled}
        sx={{
          ...sx,
          ...(Number.isInteger(check_count)
            ? {
                backgroundColor: check_count === 0 ? '#ffffff !important' : '#00bfff !important',
                color: check_count === 0 ? '#00aeff !important' : '#ffffff !important',
                fontWeight: 600,
                border: check_count === 0 ? '1px solid #00aeff !important' : '#00bfff !important',
                overflow: 'hidden',
              }
            : {}),
        }}
        isStatistics={props.isStatistics}
      >
        {title ? title : dropdownTitle}
      </StyledButton>
      <StyledMenu
        id='demo-customized-menu'
        MenuListProps={{
          'aria-labelledby': 'demo-customized-button',
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        style={menu_style}
        parent_id={id}
        isZoom={user_info.zoom_status == 90}
      >
        {dropdownContents.length > 0 ? (
          dropdownContents.map((item, idx) => {
            return [
              exposureIndex == idx ? <ExposureDivider /> : null,
              <MenuItem
                onClick={() => handleMenuClick(idx)}
                disableRipple
                key={`menu_item_${idx}`}
                disabled={
                  disable_owner
                    ? disable_owner
                    : typeof item == 'string'
                    ? setMenuDisabled(item)
                    : setMenuDisabled(item.title)
                }
              >
                <Box
                  sx={{ positon: 'relative' }}
                  className={['휴원생', '퇴원생', '미등록생'].includes(`${item}`) ? 'down' : ''}
                >
                  {typeof item == 'string'
                    ? item.replace('::disabled', '').replace('_require', '').replace('::exposure', '')
                    : item.listView}
                </Box>
              </MenuItem>,
            ];
          })
        ) : (
          <MenuItem className='empty' disableRipple disabled>
            클래스가 없습니다.
          </MenuItem>
        )}
      </StyledMenu>
    </>
  );
}

export default DropdownNormal;
